var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38505 10.4876C3.44187 11.0492 0.968909 12.1959 2.47511 13.6309C3.21088 14.3319 4.03033 14.8332 5.06058 14.8332H10.9394C11.9697 14.8332 12.7891 14.3319 13.5249 13.6309C15.0311 12.1959 12.5581 11.0492 11.6149 10.4876C9.4032 9.1706 6.5968 9.1706 4.38505 10.4876Z",
    stroke: "#F8F5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.49985C11 6.1567 9.65687 7.49985 8 7.49985C6.34315 7.49985 5 6.1567 5 4.49985C5 2.84299 6.34315 1.49985 8 1.49985C9.65687 1.49985 11 2.84299 11 4.49985Z",
    stroke: "#F8F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bb8930e6c7a9e378bf75388d2058db66.svg";
export { ForwardRef as ReactComponent };